module.exports = __webpack_public_path__ + "static/media/alert_2.f3eff655.mp3";